export const GET_MAINTENANCE_TYPE = "GET_MAINTENANCE_TYPE";
export const GET_MAINTENANCE_SUB_TYPE = "GET_MAINTENANCE_SUB_TYPE";
